// extracted by mini-css-extract-plugin
export var editInput = "_fw-0";
export var editInputCompact = "_fw-2";
export var editInputLarge = "_fw-1";
export var editInputSmall = "_fw-3";